export default __webpack_public_path__ + "hf_makers_mark-qPk.svg";